import Vue from "vue";

export default class scriptLoader extends Vue {

  static loadJs(src, id, customKey) {
      const existingScript = document.getElementById(id);
      return new Promise(function (resolve, reject) {
          if (!existingScript) {
              const script = document.createElement('script');
              script.src = src;
              script.id = id
              if(customKey) {
                  script.setAttribute(customKey.label, customKey.value)
              }
              script.onload = () => resolve(script);
              script.onerror = () => reject(new Error(`Script load error for ${src}`));
              document.head.append(script);
          } else {
              resolve(id + 'allreadyLoaded');
          }
      });
  }
  
  static loadStyle(src, id) {
      const existingScript = document.getElementById(id);
      return new Promise(function (resolve, reject) {
          if (!existingScript) {
              const element = document.createElement('link')
              element.setAttribute('rel', 'stylesheet')
              element.setAttribute('type', 'text/css')
              element.setAttribute('href', src)
              element.setAttribute('id', id)
              element.onload = () => resolve(src)
              element.onerror = () => reject(src)
              document.head.appendChild(element)
          } else {
              resolve(id + 'allreadyLoaded');
          }
      });
  }
}
